import { chakra } from '@chakra-ui/react'
import {
  PaginationProps,
  Pagination as CustomPagination,
} from '@/baseComponents'
import { GoChevronLeft, GoChevronRight } from 'react-icons/go'

export type PageInfo = {
  page: number
  pageSize: number
};

export default chakra(Pagination)
function Pagination({
  pageCount,
  pageSize,
  isRounded,
  onPageChange,
  siblingCount,
  page,
  theme = 'brand',
}: PaginationProps) {
  return (
    <CustomPagination
      page={page}
      pageButton={{
        backgroundColor: 'transparent',
        color: "gray.600",
        fontSize: 'md',
        fontWeight: 500,
        _selected: {
          borderWidth: 1,
          borderColor: `${theme}.aubergine`,
          color: "gray.800",
        },
        _hover: {
          color: "gray.800",
        },
        _active: {
          backgroundColor: "transparent",
        },
      }}
      isRounded={isRounded}
      nextButton={{
        backgroundColor: "transparent",
        color: `${theme}.aubergine`,
        'aria-label': 'Go to next page',
        icon: <GoChevronRight />,
        sx: {
          svg: {
            width: 6,
            height: 6,
          },
        },
        _hover: {
          backgroundColor: "transparent",
        },
        _active: {
          backgroundColor: "transparent",
        },
      }}
      prevButton={{
        backgroundColor: "transparent",
        color: `${theme}.aubergine`,
        'aria-label': 'Go to next page',
        icon: <GoChevronLeft />,
        sx: {
          svg: {
            width: 6,
            height: 6,
          },
        },
        _hover: {
          backgroundColor: "transparent",
        },
        _active: {
          backgroundColor: "transparent",
        },
      }}
      width='fit-content'
      Ellipsis={{
        backgroundColor: 'transparent',
        color: `${theme}.aubergine`,
      }}
      siblingCount={siblingCount}
      pageCount={pageCount}
      pageSize={pageSize}
      onPageChange={onPageChange}
    />
  )
}
